module.exports = __webpack_public_path__ + "components/country-flag/static/lk-d03cefc186337ceb0cc4f7883dc200a3.svg";